<a href (click)="download()"><div class="country-profile-export__icon-wrapper"><mat-icon svgIcon="download"></mat-icon></div>Export to Word</a>
